import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    loginStatus:false
  },
  getters: {
  },
  mutations: {
    setLogin(state,data){
      state.loginStatus = data
    }
  },
  actions: {
  },
  modules: {
  }
})
